/** Shortest abbreviation we accept as identifying a commit (git's default minimum). */
const MIN_HASH_LENGTH = 7;

/**
 * True when two abbreviated git hashes name the same commit. The running bundle and the
 * deployedHash in Firestore can be stamped in different CI runner lanes, and git may abbreviate
 * the same commit to 7 characters in one checkout and 8 in another - a plain !== then reports
 * an update forever, and reloading never clears it.
 */
export function isSameBuild(a: string, b: string): boolean {
    const x = (a || '').trim().toLowerCase();
    const y = (b || '').trim().toLowerCase();
    if (x.length < MIN_HASH_LENGTH || y.length < MIN_HASH_LENGTH) {
        return false;
    }
    return x.length <= y.length ? y.startsWith(x) : x.startsWith(y);
}
